import React, {Component} from 'react';
import {Link} from "react-router-dom";
import FocusPageId from "../../FocusPageId";
import '../Beginners.css'
class OtherTopics extends React.Component {

    constructor(props){
        super(props);

        this.focusPage = this.focusPage.bind(this);

    }

    focusPage =(elementId)=>{
        FocusPageId.selectedId={elementId}
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {

        return (
            <div className="static-pages">
                <div className="background-div">
                    <h3 className="inline-block-element"><b>その他</b></h3>
                     <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("a")}>
                        <Link to='/other'>
                            <h4><b className="reduce-font-size cart-row-text-color"> KITCUT PCBはどこにありますか？</b>
                            </h4>

                        </Link>

                    </div>


                     <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("b")}>
                        <Link to='/other'>
                            <h4><b className="reduce-font-size cart-row-text-color">対応しているブラウザの種類はなんですか？</b>
                            </h4>

                        </Link>

                    </div>

                     <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("c")}>
                        <Link to='/other'>
                            <h4> <b className="reduce-font-size cart-row-text-color">ページが正常に表示されてないようです。</b>
                            </h4>
                        </Link>

                    </div>


                     <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("d")}>
                        <Link to='/other'>
                            <h4><b className="reduce-font-size cart-row-text-color"> ログインしようとするとエラーになるのですが？</b>
                            </h4>
                        </Link>

                    </div>




                     <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("e")}>
                        <Link to='/other'>
                            <h4><b className="reduce-font-size cart-row-text-color"> サイトの使い方がよくわからないのですが？</b>
                            </h4>
                        </Link>

                    </div>


                     <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("f")}>
                        <Link to='/other'>
                            <h4><b className="reduce-font-size cart-row-text-color"> キットカットラボからのメールが届きません？</b>
                            </h4>
                        </Link>

                    </div>



                     <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("g")}>
                        <Link to='/other'>
                            <h4><b className="reduce-font-size cart-row-text-color"> キットカットラボからのメールが文字化けして読めません？</b>
                            </h4>

                        </Link>

                    </div>
                    {/*<div className='col-md-10'></div>*/}
                    <div className='faq-link-float-right   col-12-custom'>
                        <Link to="/frequent">
                            <span className='font-size-20 reduce-font-size'>
                            戻る
                            </span>
                        </Link>
                    </div>
                </div>
                </div>

        );
    }
}

export default OtherTopics;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/OtherTopics.js